export const isInStandaloneMode = () =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window.navigator as any).standalone === true ||
  window.matchMedia('(display-mode: standalone)').matches ||
  window.navigator.userAgent.includes('standalone') ||
  document.referrer.includes('android-app://')
